import { toHTML } from '../util/dom-util';

// eslint-disable-next-line no-unused-vars
const VERSION = '1.0.0';
const NAME = 'ui.loading-spinner';

class LoadingSpinner {
  constructor() {
    this._showCount = 0;
    this._template = toHTML(`
    <div class="c-loader--wrap">
      <div class="c-loader">
        <div class="c-loader--circle"></div>
      </div>
    </div>
    `);
  }

  static get NAME() {
    return NAME;
  }

  show() {
    if (this._showCount <= 0) {
      document.body.appendChild(this._template);
      // eslint-disable-next-line no-unused-vars
      const cache = this._template.offsetHeight;
      this._template.classList.add('is-active');
    }
    this._showCount++;
  }

  hide(isForceHide = false) {
    const hasParent = this._template.parentNode;
    if (isForceHide) {
      if (hasParent) {
        this._template.classList.remove('is-active');
        document.body.removeChild(this._template);
        this._showCount = 0;
      }
    } else {
      this._showCount = Math.max(this._showCount - 1, 0);
      if (this._showCount < 1) {
        if (hasParent) {
          this._template.classList.remove('is-active');
          document.body.removeChild(this._template);
        }
      }
    }
  }
}

export default new LoadingSpinner();
